import { render, staticRenderFns } from "./Residentials.vue?vue&type=template&id=50e9ef51&"
import script from "./Residentials.vue?vue&type=script&lang=js&"
export * from "./Residentials.vue?vue&type=script&lang=js&"
import style0 from "./Residentials.vue?vue&type=style&index=0&id=50e9ef51&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports